import { warning } from '../../../utils/NotificationMessages';

export const emailConfigurationErrorHandler = (error) => {
  switch (error.response.status) {
    case 408:
      return warning('Something Went Wrong , Please try again');
    case 401:
      return warning('Unauthorized Action , Please try again');
    case 500:
      return warning('Internal Server Error , Please try again');
    case 503:
      return warning('Service Unavailable , Please try again');
    default:
      return warning('Something Went Wrong , Please try again');
  }
};
